import.meta.glob("./thumbnail_editor/*.{js,hbs,jst.ejs}", { eager: true });
import "./tab_builder.js";
import "../../shared/components/tabs/tabs_manager.js";

// VITE_MIGRATION: Preserve sub-properties (Library, Uploader, Cropper) attached
// by import.meta.glob above, which runs BEFORE this assignment under ES modules.
var __previousThumbnailEditor = window.ThumbnailEditor;
window.ThumbnailEditor = class ThumbnailEditor {
  constructor(options) {
    this.render = this.render.bind(this);
    this.handleAssetChosen = this.handleAssetChosen.bind(this);
    this.handleAssetUploadStarting = this.handleAssetUploadStarting.bind(this);
    this.handleAssetUploading = this.handleAssetUploading.bind(this);
    this.handleAssetUploaded = this.handleAssetUploaded.bind(this);
    this.handleAssetUploadFailed = this.handleAssetUploadFailed.bind(this);
    this.handleThumbnailCropped = this.handleThumbnailCropped.bind(this);
    this.setTab = this.setTab.bind(this);
    this.hasImage = this.hasImage.bind(this);
    this.setThumbnail = this.setThumbnail.bind(this);
    this.getThumbnailJSON = this.getThumbnailJSON.bind(this);
    this.getThumbnail = this.getThumbnail.bind(this);
    this.getPreviewUrl = this.getPreviewUrl.bind(this);
    this.hasThumbnail = this.hasThumbnail.bind(this);
    this._dupThumbnail = this._dupThumbnail.bind(this);
    this._triggerBusy = this._triggerBusy.bind(this);
    this._triggerIdle = this._triggerIdle.bind(this);
    this._triggerEvent = this._triggerEvent.bind(this);
    if (options == null) {
      options = {};
    }
    this.el = jQuery('<div class="thumbnail-editor">');
    this.tabBuilder = new TabBuilder("tab-selectors tab-selectors--primary", "tab-content");
    this.el.append(this.tabBuilder.nav, this.tabBuilder.contentHolder);
    this.libraryTarget = jQuery('<div class="thumbnail-editor-asset-library-target">');
    this.library = new ThumbnailEditor.Library({
      detectFace: options.detectFace,
      pageType: options.pageType,
      libraryEndpoint: options.libraryEndpoint,
    });
    this.uploader = new ThumbnailEditor.Uploader({
      detectFace: options.detectFace,
      uploadEndpoint: options.uploadEndpoint,
    });
    this.cropper = new ThumbnailEditor.Cropper({ aspectRatio: options.aspectRatio, responsive: options.responsive });
    this.thumbnail = {};
    this.ready = false;

    // BEHAVIOUR

    jQuery(this.library).on("choose", this.handleAssetChosen);
    jQuery(this.uploader).on("begin", this.handleAssetUploadStarting);
    jQuery(this.uploader).on("progress", this.handleAssetUploading);
    jQuery(this.uploader).on("success", this.handleAssetUploaded);
    jQuery(this.uploader).on("fail", this.handleAssetUploadFailed);
    jQuery(this.cropper).on("crop", this.handleThumbnailCropped);
    jQuery(this.cropper).one("ready", () => (this.ready = true));

    this.tabBuilder.addTab("Library", this.library.el);
    this.tabBuilder.addTab("Upload", this.uploader.el);
    this.tabBuilder.addTab("Edit", this.cropper.el);
  }

  // RENDERING

  render() {
    if (this.hasImage()) {
      this.tabBuilder.selectTab("Edit");
    } else {
      this.tabBuilder.selectTab("Library");
    }

    this.cropper.render();
    this.library.render();
    this.uploader.render();
    return this;
  }

  // EVENT HANDLERS

  handleAssetChosen(event, asset, element) {
    return this.setThumbnail({
      assetId: asset.id,
      assetUrl: asset.url,
      originalUrl: this._previewUrlFor(asset),
      cropSettings: asset.face_bounding_box,
    }).then(() => {
      this.render();
      this.tabBuilder.selectTab("Edit");
      return this._triggerIdle();
    });
  }

  handleAssetUploadStarting() {
    return this._triggerBusy();
  }

  handleAssetUploading(event, status) {}
  // TODO: Show some working indicator

  handleAssetUploaded(event, asset) {
    return this.setThumbnail({
      assetId: asset.id,
      assetUrl: asset.url,
      originalUrl: this._previewUrlFor(asset),
      cropSettings: asset.face_bounding_box,
    }).then(() => {
      this.render();
      this.tabBuilder.selectTab("Edit");
      return this._triggerIdle();
    });
  }

  handleAssetUploadFailed() {
    return this._triggerIdle();
  }

  handleThumbnailCropped(event, cropSettings) {
    this.thumbnail.cropSettings = cropSettings;
    return this._triggerEvent("crop", this.thumbnail);
  }

  // HELPER FUNCTIONS

  setTab(tab) {
    return this.tabBuilder.selectTab(tab);
  }

  hasImage() {
    return !!this.thumbnail.originalUrl;
  }

  setThumbnail(thumbnail) {
    const deferred = new jQuery.Deferred();
    this.thumbnail = this._dupThumbnail(thumbnail);
    jQuery(this.cropper).one("ready", deferred.resolve);

    this.cropper.setImage(this.thumbnail.originalUrl, this.thumbnail.cropSettings);

    return deferred.promise().done(() => this._triggerEvent("setThumbnail"));
  }

  // Return empty string since an empty object will output a non-empty string, causing the server side to treat it as present
  getThumbnailJSON() {
    if (jQuery.isEmptyObject(this.thumbnail)) {
      return "";
    } else {
      return JSON.stringify(this.thumbnail);
    }
  }

  getThumbnail() {
    return this._dupThumbnail(this.thumbnail);
  }

  getPreviewUrl() {
    return this.cropper.getPreviewUrl();
  }

  hasThumbnail() {
    return this.thumbnail.originalUrl != null;
  }

  _previewUrlFor(asset) {
    return asset.hi_res_url || asset.poster_image_path || asset.thumbnail_url || asset.url;
  }

  _dupThumbnail(thumbnail) {
    return {
      ...thumbnail,
    }; // Copy the passed object to prevent it from being modified externally
  }

  _triggerBusy() {
    return this._triggerEvent("busy");
  }

  _triggerIdle() {
    return this._triggerEvent("idle");
  }

  _triggerEvent(name, ...payload) {
    return jQuery(this).triggerHandler(name, payload);
  }
};

// Re-attach sub-properties (Library, Uploader, Cropper, etc.) from the
// glob-imported submodules that ran before the assignment above.
if (__previousThumbnailEditor) {
  Object.assign(window.ThumbnailEditor, __previousThumbnailEditor);
}
